/**
 * @generated SignedSource<<f972ca2dd0fb00c0bd7b3c8cc06cb38e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainComponent_todo$data = {
  readonly canWrite: boolean;
  readonly id: string;
  readonly isOrg: boolean;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainFooter_todo" | "TodoEditNewMainUniversal_todo" | "TodoEditPopovers_todo" | "TodoEditTimeline_todo">;
  readonly " $fragmentType": "TodoEditNewMainComponent_todo";
};
export type TodoEditNewMainComponent_todo$key = {
  readonly " $data"?: TodoEditNewMainComponent_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainComponent_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainComponent_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainUniversal_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainFooter_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditPopovers_todo"
    },
    {
      "kind": "Defer",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoEditTimeline_todo"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "b07fdc947149228025a9131adc3c6812";

export default node;
